// src/pages/PrivacyPolicyPage.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import PrivacyPolicy from '../PrivacyPolicy';

// Update the logo URL to point to the correct location
const logoUrl = '/src/logo.svg';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#050614] via-[#0a1425] to-[#112340]">
      {/* Enhanced Navigation Header */}
      <nav className="fixed w-full bg-white/10 backdrop-blur-lg shadow-lg z-50 border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            {/* Logo section on the left */}
            <Link to="/" className="flex items-center">
              <img
                src={logoUrl}
                alt="Logo"
                className="w-10 h-10 transition-transform duration-300 ease-in-out transform hover:scale-110"
              />
              <span className="ml-2 text-xl font-bold text-white">topoSphere</span>
            </Link>
            
            {/* Main Page button on the right */}
            <Link 
              to="/" 
              className="bg-gradient-to-r from-[#d35400] to-[#e67e22] text-white px-4 py-2 rounded-lg 
                       hover:from-[#b24300] hover:to-[#c57c1f] transition-all shadow-lg flex items-center gap-2"
            >
              <Home className="w-4 h-4" />
              Main Page
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Content with Enhanced Styling */}
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl shadow-xl overflow-hidden border border-white/20">
            <div className="p-8">
              {/* Custom styling wrapper for PrivacyPolicy component */}
              <div className="prose prose-invert max-w-none">
                <div className="space-y-8">
                  <PrivacyPolicy />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#050614] text-white py-8 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} topoSphere. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;